import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SwitchLongFormBuilderOutlineSections($sectionId1: ID!, $sectionId2: ID!) {
    switchLongFormBuilderOutlineSections(sectionId1: $sectionId1, sectionId2: $sectionId2) {
      id
    }
  }
`;

export const switchLongFormBuilderOutlineSections = ({ sectionId1, sectionId2 }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { sectionId1, sectionId2 },
  }).then(({ data }) => getSingleProp(data));
};
